import React from 'react';

const MongoDB_Insert = () => {
  return (
    <div>
      <h1>MongoDB_Insert Component</h1>
      <p>This is the MongoDB_Insert page.</p>
    </div>
  );
};

export default MongoDB_Insert;
